// LineChart.js
import { Pie } from 'vue-chartjs'

export default {
  extends: Pie,
  props: ['data', 'options'],
  mounted () {
    this.renderChart(this.data, this.buildOptions())
  },
  methods: {
    buildOptions() {
      let builtOptions = {
        plugins: {
					datalabels: {
            display: false,
          }
				},
      }
      this.$lodash.merge(builtOptions, this.options)
      return builtOptions;
    }
  },
  watch: {
    data: function() {
      if (this.$data._chart) {
        this.$data._chart.destroy()
      }
      this.renderChart(this.data, this.buildOptions())
    }
  }
}
